import axios from 'axios';
import MyNavbar from '../../components/navbar/MyNavbar'
import './AddArticle.css'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import Swal from 'sweetalert2';

function AddArticle() {
  // this state below for save the information and we use it in the formHandler function.
  const [formData , setFormData] = useState({})
  // we use this fuction below for reset a data in form after make new article
  const resetFormData = () => {
    setFormData({
      title : '',
      description : '',
      image : '',
      readingTime : '',
      category : '',
      writter : ''
    })
  }


  // this function below for the button in the form secction that add a new article in db.json for us by axios package and post method.
  const addArticleHandler = () => {
    // we use formData states for get information
    axios.post('http://localhost/react/api/articles/' , formData)
    .then(response => {
      // we use status code for Error handling.
      if(response.status === 200){
        Swal.fire({
          title : 'New article successfully created',
          timer : 2500,
          timerProgressBar : true,
          icon : 'success'

       })

      }
    })
    .catch(error => {
      Swal.fire({
          title : 'The article was not created',
          timer : 2500,
          timerProgressBar : true,
          icon : 'error'
      })
    })

    // we use Sweetalert package for show message on AddArticle section page.
    
    // after make new article add success or fail to make reset the data inside the forms.
    resetFormData()
  }
  // this function below for send information in to the formData state and we use it in to the addArticleHandler function and at the end we use addArticleHandler in button section for make new article.
  const formHandler = (e) => {
    // we use name propety from form.control
    setFormData({...formData , [e.target.name] : e.target.value})

  }



  return (
    <>
      <MyNavbar />
      <div className='form-container'>
        <Form>
          {/* first form */}
          <Form.Group className="mb-3">
            <Form.Label>Article title :</Form.Label>
            {/* we use name property in to the formhandler function to get info and values. */}
            <Form.Control value={formData.title} name='title' onChange={formHandler} type="text" placeholder="Enter the title of the article" required />
          </Form.Group>
          {/* second form */}
          <Form.Group className="mb-3">
            <Form.Label>Short description :</Form.Label>
            <Form.Control value={formData.description} name='description' onChange={formHandler} type="text" placeholder="Enter a short description about the article" required />
          </Form.Group>
          {/*third form*/}
          <Form.Group className="mb-3">
            <Form.Label>Article image :</Form.Label>
            <Form.Control value={formData.image} name='image' onChange={formHandler} type="text" placeholder="Enter the image address of the article" />
          </Form.Group>
          {/* fourth form */}
           <Form.Group className="mb-3">
            <Form.Label>Reading time :</Form.Label>
            <Form.Control value={formData.readingTime} name='readingTime' onChange={formHandler} type="number" placeholder="Enter the reading time of the article" />
          </Form.Group>
          {/* fifth form */}
          <Form.Group className="mb-3">
            <Form.Label>Article category :</Form.Label>
            <Form.Control value={formData.category} name='category' onChange={formHandler} type="text" placeholder="Enter the category of the article" />
          </Form.Group>
          {/* sixth form */}
          <Form.Group className="mb-3">
            <Form.Label>Article author :</Form.Label>
            <Form.Control value={formData.writter} name='writter' onChange={formHandler} type="text" placeholder="Enter name of the author of the article" />
          </Form.Group>
          {/* give onclick function for add a article */}
          <Button onClick={addArticleHandler} className='btn-form' variant="primary" type="button">Make a Article</Button>
        </Form>
      </div>
    </>
  )
}

export default AddArticle